import { useCallback } from 'react';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { useGoogleLogin } from '@react-oauth/google';
import { useClientContext } from 'client/context';
import { GoogleAuth } from 'client/voladeum/auth/types';
import { setToken } from 'ducks/user/slices';
import { Button } from 'framework/button';
import { useAppDispatch } from 'store/hooks';

export const GoogleButton = () => {
  const dispatch = useAppDispatch();
  const { Voladeum, handleError } = useClientContext();

  const onSubmit = useCallback(
    async (token: string) => {
      try {
        const payload: GoogleAuth = { token };
        const res = await Voladeum.auth.google(payload);
        dispatch(setToken({ token: res.data }));
      } catch (err) {
        handleError(err);
      }
    },
    [Voladeum, dispatch, handleError]
  );

  const googleLogin = useGoogleLogin({
    onSuccess: async ({ access_token }) => onSubmit(access_token),
    onError: () => console.error('google login failed'),
    scope: 'openid email profile',
  });
  return (
    <Button
      left_icon={faGoogle}
      onClick={() => googleLogin()}
      width="100%"
      height="36px"
      variant="secondary"
      shadow
    >
      Sign in with Google
    </Button>
  );
};
